<div
  *ngIf="asset"
  class="row"
  [ngClass]="{ review: asset.is_review, 'device-selection': !is_offcanvas }"
>
  <div
    class="col col-12 col-sm-4 col-md-3 text-center text-sm-start bg-white item-image"
    [ngClass]="{ 'bg-white': !is_offcanvas }"
  >
    <ng-container *ngIf="getImageMetaData(asset.device?.image_url) as img">
      <img
        [ngClass]="{
          'carrier-logo':
            (additional_asset && additional_asset_type === 'line') ||
            (!additional_asset &&
              is_offcanvas &&
              [multi_sim_types[1], multi_sim_types[2], multi_sim_types[6]].includes(
                asset.multi_sim_type
              ))
        }"
        [alt]="img.alt"
        loading="lazy"
        [src]="img.src"
        (error)="imageLoadError($event, asset)"
      />
    </ng-container>
  </div>

  <div
    *ngIf="!is_offcanvas"
    class="col col-12 col-sm-8 col-md-9 text-center text-sm-start"
    [ngClass]="{ 'device-selection__info': !is_offcanvas }"
  >
    <img
      *ngIf="asset.line && asset.line?.carrier_image_url"
      class="carrier-logo"
      [src]="asset.line.carrier_image_url"
      [alt]="asset.line.carrier_name"
    />

    <div *ngIf="asset.line && asset.line?.carrier_name" class="mt-1">
      <small class="text-secondary lh-base d-block">
        {{ asset.line.carrier_name }}
      </small>
    </div>

    <div *ngIf="asset.line && asset.line.international_number" class="mt-2">
      <span class="fw-normal">{{ asset.line.international_number }}</span>
      <span
        *ngIf="asset.line.asset_primary_line && asset.multi_sim_type === multi_sim_types[0]"
        class="material-icons text-info ms-1"
      >
        verified
      </span>
    </div>
    <div
      *ngIf="asset?.device?.manufacturer && asset.device.model"
      class="lh-1"
      [ngClass]="{ 'mt-2': !!asset.line }"
    >
      <span class="fw-normal">{{ asset.device.manufacturer }} {{ asset.device.model }}</span>
      <span
        *ngIf="
          asset.device.asset_primary_device &&
          [multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)
        "
        class="material-icons text-info ms-1"
      >
        verified
      </span>
    </div>

    <div class="mt-1">
      <small class="text-secondary lh-base d-block">
        <span *ngIf="asset.device?.size"> {{ asset.device.size }} - </span>
        <span *ngIf="asset.device?.color">
          {{ asset.device.color }}
        </span>
      </small>
    </div>

    <div
      *ngIf="asset.line?.id"
      class="mt-2 me-1 d-flex gap-2 flex-wrap justify-content-center justify-content-sm-start status"
    >
      <!-- Status -->
      <ts-status-badge
        *ngIf="asset.line.status"
        [status]="asset.line.status"
        [status_display_name]="asset.line.status_display_name"
      />

      <!-- Upgrade Eligibility -->
      <ts-eligibility-badge [line]="asset.line" />
    </div>
  </div>

  <hr *ngIf="!is_offcanvas" />

  <div
    *ngIf="!is_offcanvas && !additional_asset; else offCanvasMetadata"
    class="col device-selection__metadata"
  >
    <span
      class="row row-cols-1 row-cols-sm-2"
      [ngClass]="[
        asset.is_review
          ? 'row-cols-md-1 row-cols-lg-2 row-cols-xl-1 px-3'
          : 'px-lg-5 device-selection__metadata--content'
      ]"
    >
      <div *ngFor="let display_info of asset_display_infos" class="col mb-3">
        <span class="d-block fw-normal">{{ display_info.label }}</span>
        <ng-container
          *ngTemplateOutlet="
            isValueArray(display_info.value) ? list : span;
            context: { value: display_info.value }
          "
        />
      </div>
    </span>
  </div>
</div>

<ng-template #offCanvasMetadata>
  <div class="col col-12 col-sm-8 col-md-9 ps-0">
    <div class="row">
      <div class="col d-flex align-items-center mb-3">
        <h5 class="d-inline-block mb-0">{{ additionalAssetTitle() }}</h5>
        <span
          *ngIf="additionalAssetIsPrimary()"
          class="material-icons d-inline-block ms-2 fs-inherit text-info"
        >
          verified
        </span>
        <span *ngIf="showLineBadges(asset.multi_sim_type)" class="d-inline-block ms-2">
          <ts-status-badge
            [status]="additionalAssetAsLine().status"
            [status_display_name]="additionalAssetAsLine().status_display_name"
          />
        </span>
        <span *ngIf="showLineBadges(asset.multi_sim_type)" class="d-inline-block ms-2">
          <ts-eligibility-badge [line]="additionalAssetAsLine()" />
        </span>
      </div>
    </div>
    <span class="row row-cols-1 row-cols-sm-2">
      <div *ngFor="let display_info of asset_display_infos" class="col mb-3">
        <span class="fw-normal" [ngClass]="{ 'd-block': !is_offcanvas }">
          {{ display_info.label }}{{ is_offcanvas ? ':' : '' }}
        </span>
        <ng-container
          *ngTemplateOutlet="
            isValueArray(display_info.value) ? list : span;
            context: { value: display_info.value }
          "
        />
      </div>
    </span>

    <div
      ngbAccordion
      #accordion="ngbAccordion"
      [ngClass]="['col accordion-flush']"
      [closeOthers]="true"
    >
      <div
        *ngIf="
          additional_asset_type === multi_sim_types[3] ||
          [multi_sim_types[1], multi_sim_types[5], multi_sim_types[6]].includes(
            asset.multi_sim_type
          )
        "
        ngbAccordionItem="Technical Specifications"
        [collapsed]="true"
        class="border rounded"
      >
        <h6 ngbAccordionHeader>
          <button ngbAccordionButton class="focus-visible focus-visible-inset rounded-top">
            {{ 'tech_specs' | translate }}
          </button>
        </h6>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="row">
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'description' | translate }}:</span>
                  <span>{{ fieldExists(additionalAssetAsDevice()?.tech_specs?.description) }}</span>
                </div>
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'sim_compatibility' | translate }}:</span>
                  <span>
                    {{ fieldExists(additionalAssetAsDevice()?.tech_specs?.sim_compatibility) }}
                  </span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'battery' | translate }}:</span>
                  <span>{{ fieldExists(additionalAssetAsDevice()?.tech_specs?.battery) }}</span>
                </div>
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'weight' | translate }}:</span>
                  <span>{{ fieldExists(additionalAssetAsDevice()?.tech_specs?.weight) }}</span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          additional_asset_type === multi_sim_types[4] ||
          [multi_sim_types[0], multi_sim_types[2]].includes(asset.multi_sim_type)
        "
        ngbAccordionItem="Service Details"
        [collapsed]="true"
        class="border rounded"
      >
        <h6 ngbAccordionHeader>
          <button ngbAccordionButton class="focus-visible focus-visible-inset rounded-top">
            {{ 'service_details' | translate }}
          </button>
        </h6>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="row">
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'carrier' | translate }}:</span>
                  <span>{{ fieldExists(additionalAssetAsLine()?.carrier_name) }}</span>
                </div>
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'plan' | translate }}:</span>
                  <span>{{ fieldExists(additionalAssetAsLine()?.plan?.name) }}</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col d-flex flex-column">
                  <span class="fw-normal">{{ 'add_on_features' | translate }}:</span>
                  <span
                    *ngIf="
                      (additionalAssetAsLine()?.plan && !additionalAssetAsLine()?.plan?.features) ||
                        !additionalAssetAsLine()?.plan;
                      else planFeatures
                    "
                  >
                    {{ 'n_a' | translate }}
                  </span>
                  <ng-template #planFeatures>
                    <span *ngFor="let feature of additionalAssetAsLine()?.plan?.features">
                      {{ feature?.name }}
                    </span>
                  </ng-template>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #span let-value="value">
  <span>{{ value }}</span>
</ng-template>

<ng-template #list let-values="value">
  <ul class="list-unstyled m-0">
    <li *ngFor="let value of values">
      {{ value }}
    </li>
  </ul>
</ng-template>
